var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        "nudge-bottom": 6,
        "min-width": _vm.menuWidth,
        "max-width": 320,
        "close-on-content-click": false,
        "content-class": "portal-select-menu"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "button",
                _vm._g(
                  _vm._b(
                    {
                      ref: "trigger",
                      class: [
                        "portal-select-field",
                        _vm.fieldClass,
                        { "is-open": _vm.menuOpen }
                      ],
                      attrs: {
                        type: "button",
                        "aria-label": _vm.label,
                        "aria-expanded": _vm.menuOpen ? "true" : "false",
                        "aria-haspopup": "listbox"
                      }
                    },
                    "button",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("span", { staticClass: "select-label" }, [
                    _vm._v(_vm._s(_vm.label))
                  ]),
                  _c("span", { staticClass: "select-value" }, [
                    _vm._v(_vm._s(_vm.selectedLabel))
                  ]),
                  _c("portal-icon", {
                    staticClass: "select-chevron",
                    attrs: {
                      name: "chevron-down",
                      size: 16,
                      "aria-hidden": "true"
                    }
                  })
                ],
                1
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.menuOpen,
        callback: function($$v) {
          _vm.menuOpen = $$v
        },
        expression: "menuOpen"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "portal-select-options",
          attrs: { role: "listbox", "aria-label": _vm.label }
        },
        _vm._l(_vm.options, function(option) {
          return _c(
            "button",
            {
              key: String(option.value),
              staticClass: "portal-select-option",
              class: { "is-selected": _vm.isSelected(option) },
              attrs: {
                type: "button",
                role: "option",
                "aria-selected": _vm.isSelected(option) ? "true" : "false"
              },
              on: {
                click: function($event) {
                  return _vm.selectOption(option)
                }
              }
            },
            [
              _c("span", [_vm._v(_vm._s(option.text))]),
              _vm.isSelected(option)
                ? _c("portal-icon", {
                    attrs: { name: "check", size: 16, "aria-hidden": "true" }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }